<span [class]="caretClasses()" aria-hidden="true"></span>
@if (contentTemplate(); as template) {
  <ng-container [ngTemplateOutlet]="template" />
} @else {
  {{ content() }}
}
